@if (serviceRequired) {
  <span [title]="'Boatmen on arrival at ' + nextBerthName" class="text-muted">
    <span class="fa fa-fw fa-link me-1"></span>{{ service.serviceProvider?.name }}
  </span>
}
